<template>
<div>
    <div class="position"></div>
    <van-tabbar v-model="activeName" active-color="#F34740" inactive-color="#999999">
        <van-tabbar-item v-for="(item,index) in list" :key="index" :name="item.name" replace :to="item.path">
            <span class="title">{{item.title}}</span>
            <template #icon="props">
                <img class="icon" :src="props.active ? item.active : item.inactive" />
            </template>
        </van-tabbar-item>
    </van-tabbar>
</div>
   
</template>

<script>
export default {
    props:["active"],
    data() {
        return {
           list:[{title:"产品管理",name:"agentProductList",path:"/",active:require("@/assets/icons/chanpinguanli.png"),inactive:require("@/assets/icons/chanpinguanli1.png")},
                {title:"客户管理",name:"agentMy",path:"/agentMy",active:require("@/assets/icons/kehuguanli.png"),inactive:require("@/assets/icons/kehuguanli1.png")}
           ]
        };
    },
    computed:{
        activeName:{
            get(){
                return this.active;
            },
            set(newValue){
                return newValue
            }
        }
    },
}
</script>

<style scoped>
    .position{
        width:100%;
        height:50px;
    }
    .title{
        font-size: 12px;
    }
    .icon{
        width:21px;
        height: 21px;
    }
    .van-tabbar{
        border-top: 2px solid #ECECEC;
    }
</style>


// WEBPACK FOOTER //
// src/components/agentTabbar.vue